
import TabComponent from "./Tab/index.vue";
import TableElement from "./Element/Table/index.vue";
import GalleryElement from "./Element/Gallery/index.vue";
import FilesElement from "./Element/Files/index.vue";
import ContentEditorElement from "./Element/ContentEditor/index.vue";

export default {
    components: {
        TabComponent, TableElement, GalleryElement, FilesElement, ContentEditorElement,
    },
    props: {
        card: {
            type: Object,
        },
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab;
        },
    },
    data() {
        const tabs = this.card.content.tabs;

        return {
            activeTab: tabs[0] || null,
            tabs: tabs,

        };
    },
};
